<template>
  	<div class="page">
		<div class="page-detail">
			<div v-if="applyState == 'ing' " class="top-state">
				0元试用{{stage}} 火热进行中

			</div>
			<div class="logo"  v-if="applyState == 'ing' " style="margin-top: -0.105263rem;" >
				<img src="@/assets/logo.png" />
			</div>
			<div class="logo"  v-if="applyState != 'ing' " style="padding-top: 0.105263rem;" >
				<img src="@/assets/logo.png" />
			</div>
			<banner v-if="bannerImg"  :bannerImg="bannerImg"   />
			<div style="margin-top: 0.157894rem;" class="container">
					<div class="containerHeader"></div>
					<div class="containerMiddle">
						<apply-state   />
						<div style="margin-top: 0.042105rem;    margin-bottom: 0.157894rem;" class="userInfo">
						<div class="tx">
							<img class="portrait"  v-if="avatar" :src="avatar" />
						</div>
						<div class="name">
							{{nickname}}
						</div>
						</div>
						<div class="content center ">
									<countdown class="countdown"   />
									<div class="row">
									<btnGroup style="margin-top: 0.157894rem;" state="a" :activityId="activityId" />
									</div>
						</div>
						<div class="content ">
							<div class="row  ">
								<h3 class="">等你来赞</h3>
							</div>
							<likeList :likeList="likeList"  />
							<div class="row  ">
								<h4 class="">已有{{likeTotal}}个赞，快来为ta点赞吧</h4>
							</div>
						</div>

						<div style="padding-top: 0.157894rem;" class="content">
							<h3>活动规则</h3>
							<div style="    font-size: 14px;" class="activityRule detail_info" v-html="rule"></div>
						</div>
					</div>
					<div class="containerFooter"></div>
			</div>
		</div>
	</div>
</template>

<script>
import countdown from '@/components/Countdown.vue';
import likeList from '@/components/likeList.vue';
import banner from '@/components/banner.vue';
import btnGroup from '@/components/btnGroup.vue';
import applyState from '@/components/apply-state.vue';
import { mapState } from 'vuex'



export default {
  name: 'page1',
  data(){
	return{
		 bannerImg : '',
		 nickname : '',
		 avatar : '',
		 likeList : '',
		 rule : '',
		 stage : '',
		 price : '',
		 likeTotal: 0,
		 activityId: '',
	}
  },
  beforeCreate(){
	  //console.log([this.$route.params.id])
	this.axios
	     .get('/campaigns-b/try/index.php?_c=show&_a=getReplylist&aid='+this.$route.params.id)
	     .then((response) => {
				  console.log(response)
				  var d = response.data.data;
				   this.likeList = d.rows;
				   this.likeTotal = d.total;

			  })
			  .catch(function (error) { // 请求失败处理
			    console.log(error);
			  });


	this.axios
	     .get('/campaigns-b/try/index.php?_c=show&_a=get&aid='+this.$route.params.id)
	     .then((response) => {
			 console.log(response)
			 var d = response.data.data;

			 this.bannerImg = d.detail.show_ban_pc;
			 this.nickname = d.nickname;
			 this.avatar = d.avatar;
			// this.likeList = d.replylist;
			 this.rule = d.detail.show_rule_pc;
			 this.stage = d.detail.try_stage;
			 this.activityId = d.try_id;
			 this.$store.commit('init',{
				 startTime : (new Date( d.detail.date_begin.replace(/-/g,'/')).getTime()),
				 endTime : (new Date( d.detail.date_end.replace(/-/g,'/')).getTime()),
				 price : d.detail.try_price,
				 stage : d.detail.try_stage
			 });

			 config.routerCallback(Object.assign({},d,{pageName:'show'}));
		 })
	     .catch(function (error) { // 请求失败处理
	       console.log(error);
	     });
  },
  created(){
	  console.log('created show')
  },
  computed: {
		... mapState([
			  'init',
			//  'activityRule',
			//  'liked',
			//  'userName',
			//  'userPortrait',
			//  'newPrice',
			//  'stage',
			  'applyState'
		])
  },
  components: {
     countdown
	 ,likeList
	 ,banner
	 ,btnGroup
	 ,applyState
  }
}
</script>

<style scoped>
.page{
	width: 100%;
	height: auto;
	min-height: 100vh;
	background: url(~@/assets/img/page-detail-bg.png) top no-repeat ,#0C73D8;
}
.page-detail{
	margin: 0 auto;
	width: 4.736842rem;
}
	.countdown{
		width: 1.821052rem;
		height: 0.294736rem;
		position: absolute;
		top: -0.142105rem;
		left: 50%;
		margin-left: -0.910526rem;
	}

	.Countdown{
		background-image: url('./../assets/count-down-bg.png');
	}

	.activityRule{
		color: $themeColor;
		padding: 0.315789rem;
		padding-top: 0.105263rem;
		line-height:0.210526rem;
	}

	.activityRule p{

	}
</style>
